import React from 'react';
import CustomModal from "../../components/CustomModal";
import WarningModal from "../../components/WarningModal";

interface CustomModalState {
  isOpen: boolean;
  title: string;
  message: string;
  type: "success" | "error" | "loading" | "confirmation" | "warning";
  onConfirm?: () => void;
}

interface SharePointModalsProps {
  customModal: CustomModalState;
  setCustomModal: React.Dispatch<React.SetStateAction<CustomModalState>>;
  modalRefreshNModal: boolean;
  setModalRefreshNModal: (open: boolean) => void;
}

const SharePointModals: React.FC<SharePointModalsProps> = ({
  customModal,
  setCustomModal,
  modalRefreshNModal,
  setModalRefreshNModal
}) => {
  return (
    <>
      {/* Custom Modal - handles confirmation, success, error, loading modals */}
      <CustomModal
        isOpen={customModal.isOpen}
        onClose={() => setCustomModal({ ...customModal, isOpen: false })}
        onConfirm={customModal.onConfirm}
        title={customModal.title}
        message={customModal.message}
        type={customModal.type}
      />

      {/* Warning Modal - for refresh nightly warning */}
      <WarningModal
        isOpen={modalRefreshNModal}
        onClose={() => setModalRefreshNModal(false)}
        message="Data will be refreshed nightly only if the assistant is published."
      />
    </>
  );
};

export default SharePointModals;